export enum PrivateProjectDocumentsParams {
  projectUuid = "projectUuid",
  projectDocumentUuid = "projectDocumentUuid",
}
